import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    storageKeys: [],
    gettingStorageKeys: false,
    creatingStorageKey: false,
    deletingStorageKey: false,
  },
  mutations: {
    SET_STORAGE_KEYS(state, data) {
      state.storageKeys = data
    },
    SET_GETTING_STORAGE_KEYS(state, value) {
      state.gettingStorageKeys = value
    },
    SET_CREATING_STORAGE_KEY(state, value) {
      state.creatingStorageKey = value
    },
    SET_DELETING_STORAGE_KEY(state, value) {
      state.deletingStorageKey = value
    },
    DELETE_STORAGE_KEY(state, name) {
      state.storageKeys = state.storageKeys.filter(s => s.name !== name)
    },
  },
  actions: {
    getStorageKeys({ commit }) {
      commit('SET_GETTING_STORAGE_KEYS', true)
      return new Promise((resolve, reject) => {
        api('storage').get(`/v1/projects/${projectId()}/storage/keys`)
          .then(response => {
            commit('SET_STORAGE_KEYS', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_STORAGE_KEYS', false) })
      })
    },
    createStorageKey({ commit }, key) {
      commit('SET_CREATING_STORAGE_KEY', true)
      const isSwift = key.type === 'swift'
      return new Promise((resolve, reject) => {
        api('storage').post(`/v1/projects/${projectId()}/storage/${isSwift ? 'swift' : 's3'}`, { name: key.name })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_CREATING_STORAGE_KEY', false) })
      })
    },
    deleteStorageKey({ commit }, key) {
      commit('SET_DELETING_STORAGE_KEY', key.name)
      const isSwift = key.type === 'swift'
      return new Promise((resolve, reject) => {
        api('storage').delete(`/v1/projects/${projectId()}/storage/${isSwift ? 'swift' : 's3'}?name=${key.name}`)
          .then(response => {
            commit('DELETE_STORAGE_KEY', key.name)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_DELETING_STORAGE_KEY', false) })
      })
    },
  },
}
